import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import MUIList from 'material-ui/List'
import classNames from 'classnames'

const styles = theme => ({
  List: {
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: 0,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    background: '#fff',
  },
})

const Panel = ({classes, children, ...props}) => {
  const totalChildren = React.Children.count(children)
  return (
    <MUIList className={classNames(classes.List)} {...props}>
      {React.Children.map(children, (c, i) => {
        if (!c) return null

        let position = ''
        if (totalChildren === 1) {
          position = 'LoneWolf'
        } else if (i === 0) {
          position = 'First'
        } else if (i === totalChildren - 1) {
          position = 'Last'
        } else {
          position = 'InBetween'
        }
        return React.cloneElement(c, {key: i, position})
      })}
    </MUIList>
  )
}

Panel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default withStyles(styles, {withTheme: true})(Panel)



// WEBPACK FOOTER //
// ./src/components/panel.jsx